module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_6005.b613c155.png";